export type EventLanguageCode = "ger" | "eng" | "ita" | "cze";

export const supportedEventLanguages: EventLanguageCode[] = [
  "ger",
  "eng",
  "ita",
  "cze",
];

export const defaultEventLanguage: EventLanguageCode = "eng";

export const preferredUiEventLanguages: EventLanguageCode[] = ["ger", "eng"];
export const eventLanguageOrder: EventLanguageCode[] = ["ger", "eng", "ita", "cze"];

/** UI labels for creator source / translation source language selectors */
export const creatorSourceLanguageSelectLabels: Record<EventLanguageCode, string> = {
  ger: "Deutsch (DE)",
  eng: "English (EN)",
  ita: "Italiano (IT)",
  cze: "Čeština (CZ)",
};

const languageAliases: Record<string, EventLanguageCode> = {
  de: "ger",
  deu: "ger",
  ger: "ger",
  en: "eng",
  eng: "eng",
  it: "ita",
  ita: "ita",
  cs: "cze",
  cz: "cze",
  cze: "cze",
  ces: "cze",
};

export const normalizeEventLanguage = (value?: string | null): string => {
  const key = (value ?? "").trim().toLowerCase();
  return languageAliases[key] ?? key;
};

export const eventLanguageSortRank = (code: string): number => {
  const normalized = normalizeEventLanguage(code);
  const idx = eventLanguageOrder.indexOf(normalized as EventLanguageCode);
  return idx >= 0 ? idx : 999;
};

export const pdfFileNameForLanguage = (language: string): string => {
  const normalized = normalizeEventLanguage(language);
  if (normalized === "eng") return "AGV_Event_Messages_Reference_EN.pdf";
  if (normalized === "ita") return "AGV_Event_Messages_Reference_IT.pdf";
  if (normalized === "cze") return "AGV_Event_Messages_Reference_CZ.pdf";
  return "AGV_Event_Messages_Reference_DE.pdf";
};

/** HMI label for the creator primary language (matches attributes.creator_source_language). */
export function getHmiLabelForCreatorPrimary(
  descriptions: { language_code: string; label?: string }[] | null | undefined,
  creatorSourceLanguage: string | null | undefined
): string {
  if (!descriptions?.length) return "";
  const primary = normalizeEventLanguage(creatorSourceLanguage) || "ger";
  const row = descriptions.find(
    (d) => normalizeEventLanguage(d.language_code) === primary
  );
  return row?.label ?? "";
}
